import { Injectable } from '@angular/core';
import moment from 'moment';
import { Subject } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { PaymentUi } from '@aiwyn/api';

@Injectable({
  providedIn: 'root'
})
export class PreviousPaymentsService {

  dataSourcePreviousPayments = new MatTableDataSource<PaymentUi>();

  previousPaymentsLoaded$ = new Subject<void>();

  constructor() {
    // Initialize filter predicate for search bar.
    this.dataSourcePreviousPayments.filterPredicate = this.searchFilterFunction;
    this.dataSourcePreviousPayments.sortingDataAccessor = this.sortingFunction;
  }

  /**
   * Sets date used calculate date range based of user dropdown selection.
   * @param value
   */
  apiDateParameters(value: string): string {
    let beginningDate = moment();
    let returnString: string;
    if (value == 'Show - Past 3 Months') {
      returnString = beginningDate.subtract(3, 'month').format('YYYY-MM-DD');
    } else if (value == 'Show - Past 6 Months') {
      returnString = beginningDate.subtract(6,'month').format('YYYY-MM-DD');
    } else if (value == 'Show - Past Year') {
      returnString = beginningDate.subtract(12,'month').format('YYYY-MM-DD');
    } else {
      returnString = "";
    }
    return returnString
  }

  /**
   * Aids search bar filtration.
   * @param data
   * @param filter
   */
  searchFilterFunction(data: PaymentUi, filter: string): boolean {
    return  data.payment.allocated.toString().toLowerCase().includes(filter)
      || data.payment.cardType?.toLowerCase().includes(filter)
      || data.payment.last4?.toLowerCase().includes(filter)
      || data.invoices.some((invoice) => { return invoice.invoiceNumber.toString().includes(filter)})
      || data.payment.statusSearchString?.toLowerCase().includes(filter)
      || data.client.name.toLowerCase().includes(filter)
  };

  /**
   * Defines sorting parameters.
   * @param item
   * @param property
   */
  sortingFunction(item, property) {
    switch (property) {
      case 'date': {
        return new Date(item.payment.arTran.transactionDate);
      }

      case 'amount': {
          return item.payment.allocated;
      }

      case 'client': {
        return item.client.name;
      }

      case 'method': {
        return item.payment.cardType + item.payment.last4;
      }

      default: {
        return item['payment'][property];
      }
    }
  }
}
